export enum TankType {
    TOTE = 'Tote',
    DRUM = 'Drum',
    SILO = 'Silo',
}
